// src/components/ui/modalArea.js
//
// Where a modal dialog is centred. Shared by WizardModal, AdminModal (hence every ConfirmDialog) and the console's own user / run dialogs, so every
// dialog sits over the page it belongs to rather than over page + sidebar.
import { useLayoutEffect, useState } from 'react';

// The page's CONTENT area (the shell's right column, beside the sidebar) carries this attribute. The overlay still
// covers the whole window — the sidebar must stay inert — but the dialog is centred in that area, not in the
// window, so it sits over the page it belongs to. No such element (public screens, tests) → centred in the window.
export const MODAL_AREA_ATTR = 'data-modal-area';

/** The left inset of the content area, kept in step with the sidebar collapsing / expanding and window resizes. */
export function useContentInset(open) {
  const [left, setLeft] = useState(0);
  useLayoutEffect(() => {
    if (!open) return undefined;
    const area = document.querySelector(`[${MODAL_AREA_ATTR}]`);
    if (!area) return undefined;
    const measure = () => setLeft(Math.max(0, Math.round(area.getBoundingClientRect().left)));
    measure();
    window.addEventListener('resize', measure);
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    if (observer) observer.observe(area);
    return () => {
      window.removeEventListener('resize', measure);
      if (observer) observer.disconnect();
    };
  }, [open]);
  return left;
}
